import { heading, text, button, image, divider, spacer, social, footerBlk, headerBar, columns, hero } from './builders'

const FOOTER = footerBlk(
  'You are receiving this email because you signed up at <strong>Maple &amp; Co.</strong><br/>123 Market Street, Suite 400, San Francisco, CA 94103<br/><a href="#unsubscribe">Unsubscribe</a> &nbsp;|&nbsp; <a href="#preferences">Update preferences</a> &nbsp;|&nbsp; <a href="#browser">View in browser</a>',
  { backgroundColor: '#f4f4f5', color: '#71717a', fontSize: '12' }
)

const TEMPLATES = [
  {
    id: 'retail-welcome-discount',
    category: 'retail',
    name: 'Welcome + First-Order Discount',
    description: "Warm welcome email with a 10% first-order discount code and a shop-now CTA.",
    blocks: [
      headerBar({
        desktopLayout: 'logo_centered',
        logoAlignment: 'center',
        backgroundColor: '#ffffff',
        linkColor: '#18181b',
        links: [
          { id: 'l1', kind: 'link', label: 'Shop', url: '#shop' },
          { id: 'l2', kind: 'link', label: 'New In', url: '#new' },
          { id: 'l3', kind: 'link', label: 'Sale', url: '#sale' }
        ]
      }),
      hero('WELCOME TO THE FAMILY', '1d4ed8', 'ffffff', {}),
      spacer('24'),
      heading('Welcome, $first_name!', { fontSize: '28', fontWeight: '700', alignment: 'center', color: '#18181b' }),
      text(
        'We are so glad you joined <strong>Maple &amp; Co.</strong> To get you started, here is a little something to spend on your very first order. Thoughtfully made pieces, delivered right to your door.',
        { fontSize: '15', color: '#3f3f46', alignment: 'center', lineHeight: '1.6', paddingTop: '8', paddingBottom: '16' }
      ),
      heading('Take 10% off your first order', { fontSize: '20', fontWeight: '600', alignment: 'center', color: 'var(--brand-primary-hover)' }),
      text(
        'Use code <strong style="letter-spacing:1px;">$discount_code</strong> at checkout. Valid for the next 14 days.',
        { fontSize: '15', color: '#3f3f46', alignment: 'center', lineHeight: '1.6', paddingTop: '4', paddingBottom: '20' }
      ),
      button('Shop Now', '#shop', { backgroundColor: 'var(--brand-primary-hover)', textColor: '#ffffff', borderRadius: '8', fontSize: '16', alignment: 'center', buttonPaddingH: '32', buttonPaddingV: '14' }),
      spacer('28'),
      divider({ color: '#e4e4e7', thickness: '1', style: 'solid' }),
      social({ alignment: 'center', iconColor: 'var(--brand-primary-hover)' }),
      FOOTER
    ]
  },
  {
    id: 'retail-new-collection',
    category: 'retail',
    name: 'New Collection / Seasonal Sale',
    description: 'Vibrant seasonal drop announcement with a bold hero and shop-the-collection CTA.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_inline',
        logoAlignment: 'left',
        backgroundColor: '#ffffff',
        linkColor: '#18181b',
        links: [
          { id: 'l1', kind: 'link', label: 'Women', url: '#women' },
          { id: 'l2', kind: 'link', label: 'Men', url: '#men' },
          { id: 'l3', kind: 'link', label: 'Accessories', url: '#acc' }
        ]
      }),
      hero('THE AUTUMN COLLECTION IS HERE', 'b45309', 'fff7ed', {}),
      spacer('24'),
      heading('New season, new favorites', { fontSize: '28', fontWeight: '700', alignment: 'center', color: '#7c2d12' }),
      text(
        'Warm tones, soft knits, and everyday essentials made to layer. Our Autumn Collection just dropped, $first_name, and the best pieces move fast.',
        { fontSize: '15', color: '#3f3f46', alignment: 'center', lineHeight: '1.6', paddingTop: '8', paddingBottom: '16' }
      ),
      // ONE argument: columns(cols, props). Passing the second column as a second
      // positional argument made it the `props` object, so it was spread into the
      // block's props and never rendered — this template showed a single product.
      columns([
        [
          image('https://placehold.co/280x320.png', { width: '100', alignment: 'center', borderRadius: '10' }),
          heading('Cozy Knitwear', { fontSize: '16', fontWeight: '600', alignment: 'center', color: '#18181b', paddingTop: '10' }),
          text('From $48', { fontSize: '14', color: '#71717a', alignment: 'center' })
        ],
        [
          image('https://placehold.co/280x320.png', { width: '100', alignment: 'center', borderRadius: '10' }),
          heading('Everyday Outerwear', { fontSize: '16', fontWeight: '600', alignment: 'center', color: '#18181b', paddingTop: '10' }),
          text('From $89', { fontSize: '14', color: '#71717a', alignment: 'center' })
        ]
      ]),
      spacer('20'),
      button('Shop the Drop', '#collection', { backgroundColor: '#b45309', textColor: '#ffffff', borderRadius: '8', fontSize: '16', alignment: 'center', buttonPaddingH: '32', buttonPaddingV: '14' }),
      spacer('28'),
      divider({ color: '#e4e4e7', thickness: '1', style: 'solid' }),
      social({ alignment: 'center', iconColor: '#b45309' }),
      FOOTER
    ]
  },
  {
    id: 'retail-loyalty-points',
    category: 'retail',
    name: 'Loyalty Points Update',
    description: 'Friendly loyalty statement showing the current points balance with a redeem CTA.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_centered',
        logoAlignment: 'center',
        backgroundColor: '#ffffff',
        linkColor: '#18181b',
        links: [
          { id: 'l1', kind: 'link', label: 'Rewards', url: '#rewards' },
          { id: 'l2', kind: 'link', label: 'Shop', url: '#shop' }
        ]
      }),
      hero('YOUR REWARDS BALANCE', '059669', 'ecfdf5', {}),
      spacer('16'),
      heading('Hi $first_name, your points are adding up!', { fontSize: '24', fontWeight: '700', alignment: 'center', color: '#18181b' }),
      spacer('12'),
      heading('$points_balance points', { fontSize: '40', fontWeight: '700', alignment: 'center', color: '#059669', backgroundColor: '#ecfdf5', paddingTop: '24', paddingBottom: '24' }),
      text(
        'That is enough to unlock real savings on your next order. Every purchase, review, and referral brings you closer to your next reward, so keep going!',
        { fontSize: '15', color: '#3f3f46', alignment: 'center', lineHeight: '1.6', paddingTop: '16', paddingBottom: '8' }
      ),
      text(
        '<strong>500 points</strong> = $5 off &nbsp;&bull;&nbsp; <strong>1,000 points</strong> = $12 off &nbsp;&bull;&nbsp; <strong>2,500 points</strong> = $35 off',
        { fontSize: '14', color: '#52525b', alignment: 'center', lineHeight: '1.8', paddingBottom: '20' }
      ),
      button('Redeem My Points', '#redeem', { backgroundColor: '#059669', textColor: '#ffffff', borderRadius: '8', fontSize: '16', alignment: 'center', buttonPaddingH: '32', buttonPaddingV: '14' }),
      spacer('28'),
      divider({ color: '#e4e4e7', thickness: '1', style: 'solid' }),
      social({ alignment: 'center', iconColor: '#059669' }),
      FOOTER
    ]
  },
  {
    id: 'retail-store-event',
    category: 'retail',
    name: 'Store Event Invite',
    description: 'In-store event invitation with date, location, and an RSVP call to action.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_centered',
        logoAlignment: 'center',
        backgroundColor: '#ffffff',
        linkColor: '#18181b',
        links: [
          { id: 'l1', kind: 'link', label: 'Events', url: '#events' },
          { id: 'l2', kind: 'link', label: 'Shop', url: '#shop' }
        ]
      }),
      hero('YOU ARE INVITED', '7c3aed', 'f5f3ff', {}),
      spacer('24'),
      heading('An evening at Maple &amp; Co.', { fontSize: '28', fontWeight: '700', alignment: 'center', color: '#4c1d95' }),
      text(
        'Hi $first_name, join us for an exclusive after-hours shopping night. Enjoy first access to the new season, styling from our team, complimentary refreshments, and a special gift for every guest.',
        { fontSize: '15', color: '#3f3f46', alignment: 'center', lineHeight: '1.6', paddingTop: '8', paddingBottom: '16' }
      ),
      text(
        '<strong>Thursday, August 14 &bull; 6:00&ndash;9:00 PM</strong><br/>Maple &amp; Co. Flagship Store<br/>123 Market Street, San Francisco, CA',
        { fontSize: '16', color: '#18181b', alignment: 'center', lineHeight: '1.8', backgroundColor: '#f5f3ff', paddingTop: '18', paddingBottom: '18' }
      ),
      spacer('20'),
      button('RSVP Now', '#rsvp', { backgroundColor: '#7c3aed', textColor: '#ffffff', borderRadius: '8', fontSize: '16', alignment: 'center', buttonPaddingH: '36', buttonPaddingV: '14' }),
      text('Spaces are limited &mdash; please RSVP by August 10.', { fontSize: '13', color: '#71717a', alignment: 'center', paddingTop: '12' }),
      spacer('24'),
      divider({ color: '#e4e4e7', thickness: '1', style: 'solid' }),
      social({ alignment: 'center', iconColor: '#7c3aed' }),
      FOOTER
    ]
  },
  {
    id: 'retail-back-in-stock',
    category: 'retail',
    name: 'Back-in-Stock',
    description: 'Back-in-stock alert for a wishlisted product with a buy-before-it-goes CTA.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_centered',
        logoAlignment: 'center',
        backgroundColor: '#ffffff',
        linkColor: '#18181b',
        links: [
          { id: 'l1', kind: 'link', label: 'Shop', url: '#shop' },
          { id: 'l2', kind: 'link', label: 'Wishlist', url: '#wishlist' }
        ]
      }),
      hero('BACK IN STOCK', 'dc2626', 'fff1f2', {}),
      spacer('16'),
      heading('Good news, $first_name &mdash; it is back!', { fontSize: '26', fontWeight: '700', alignment: 'center', color: '#18181b' }),
      text(
        'The item you were waiting for is back in stock. These sell out quickly, so grab yours before it disappears again.',
        { fontSize: '15', color: '#3f3f46', alignment: 'center', lineHeight: '1.6', paddingTop: '8', paddingBottom: '16' }
      ),
      image('https://placehold.co/560x360.png', { width: '100', alignment: 'center', borderRadius: '12', link: '#product' }),
      spacer('16'),
      heading('$product_name', { fontSize: '20', fontWeight: '600', alignment: 'center', color: '#18181b' }),
      text('Back in all sizes &bull; Ships within 24 hours', { fontSize: '14', color: '#dc2626', alignment: 'center', paddingTop: '4', paddingBottom: '18' }),
      button("Buy It Before It's Gone", '#product', { backgroundColor: '#dc2626', textColor: '#ffffff', borderRadius: '8', fontSize: '16', alignment: 'center', buttonPaddingH: '30', buttonPaddingV: '14' }),
      spacer('28'),
      divider({ color: '#e4e4e7', thickness: '1', style: 'solid' }),
      social({ alignment: 'center', iconColor: '#dc2626' }),
      FOOTER
    ]
  },
  {
    id: 'retail-weekend-flash-sale',
    category: 'retail',
    name: 'Weekend Flash Sale',
    description: 'Bold weekend flash sale with up-to-50%-off messaging and an urgent countdown vibe.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_centered',
        logoAlignment: 'center',
        backgroundColor: '#18181b',
        linkColor: '#ffffff',
        links: [
          { id: 'l1', kind: 'link', label: 'Shop Sale', url: '#sale' },
          { id: 'l2', kind: 'link', label: 'New In', url: '#new' }
        ]
      }),
      hero('WEEKEND FLASH SALE', 'e11d48', 'fff1f2', {}),
      spacer('20'),
      heading('Up to 50% off &mdash; this weekend only', { fontSize: '30', fontWeight: '700', alignment: 'center', color: '#e11d48' }),
      text(
        '$first_name, the biggest markdowns of the season are live right now. Hundreds of styles reduced, but only until Sunday at midnight. When it is gone, it is gone.',
        { fontSize: '15', color: '#3f3f46', alignment: 'center', lineHeight: '1.6', paddingTop: '8', paddingBottom: '12' }
      ),
      heading('&#9203; Ends Sunday at 11:59 PM', { fontSize: '18', fontWeight: '700', alignment: 'center', color: '#ffffff', backgroundColor: '#e11d48', paddingTop: '14', paddingBottom: '14' }),
      spacer('20'),
      button('Shop Now', '#sale', { backgroundColor: '#e11d48', textColor: '#ffffff', borderRadius: '8', fontSize: '18', alignment: 'center', buttonPaddingH: '40', buttonPaddingV: '16' }),
      text('No code needed &mdash; discounts applied automatically at checkout.', { fontSize: '13', color: '#71717a', alignment: 'center', paddingTop: '12' }),
      spacer('24'),
      divider({ color: '#e4e4e7', thickness: '1', style: 'solid' }),
      social({ alignment: 'center', iconColor: '#e11d48' }),
      FOOTER
    ]
  }
]

export default TEMPLATES
